import React from 'react';
import { Link } from 'react-router-dom';
import './topBar.css';
import UserPainelWidget from '../userPainel.js'
import withStyles from '@material-ui/core/styles/withStyles';
import { NSCTotalService } from '../../services/NscTotalService';
import Auth from '../../services/AuthService';
import decode from "jwt-decode";
import UrlHelper from '../../Helpers/urlHelper';


const styles = theme => ({
    listItems: {
        display: 'inline-block',
        minHeight: '42px',
        height: '42px',
        listStyleType: 'none',
        marginTop: '-42px !important',
        marginLeft: '45px !important',
        margin: '0px 0px 0px -20px',
        padding: '0px',
        overflow: 'hidden',
        marginBlockStart: '0',
        marginBlockEnd: '0',
        marginInlineStart: '0px',
        marginInlineEnd: '0px',
        paddingInlineStart: '0px',
        float: 'left',
        fontSize: '17px',
        fontWeight: 'bolder',
        position: 'relative',
        '& li': {
          display: 'list-item',
          textAlign: '-webkit-match-parent',
          listStyleType: 'none',
          float: 'left',
          fontSize: '17px',
          fontWeight: 'bolder',
          position: 'relative',
          '& :first-child': {
            '& a': {
              display: 'block',
              color: 'rgb(255, 105, 21)',
              textAlign: 'center',
              padding: '8px 15px',
              textDecoration: 'none',
            }
          },
          '& a': {
            display: 'block',
            color: 'rgb(113, 113, 113)',
            textAlign: 'center',
            padding: '8px 15px',
            textDecoration: 'none',
          },
          '& a:hover': {
            backgroundColor: 'rgb(221, 221, 221)',
          },
        },
        '& li:first-child': {
          '& a': {
            display: 'block',
            color: 'rgb(255, 105, 21)',
            textAlign: 'center',
            padding: '8px 15px',
            textDecoration: 'none',
          },
        },
        '& li:not(:last-child)': {
          marginRight: '-2px',
        },
        '& li:hover': {
          backgroundColor: 'rgb(221, 221, 221)',
        },
        '& li:not(:first-child)::before': {
          content: '""',
          top: '50%',
          transform: 'translateY(-50%)',
          position: 'absolute',
          width: '2px',
          height: '14px',
          backgroundColor: 'rgb(222, 222, 222)',
          left: '0px',
        },
      },
      containerRight: {
        float: 'right',
        display: 'inline-flex',
        alignItems: 'center',
        margin: '5px 0 0 0',
        marginTop: '-37px !important',
        marginRight: '45px !important',
        [theme.breakpoints.down('xs')]: {
          display: 'none',
        },
        '& .buttonAssineJa': {
          boxSizing: 'border-box',
          outlineStyle: 'none',
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '0.85em',
          backgroundColor: 'rgb(255, 105, 21)',
          color: 'white',
          display: 'none', // hide assine já button
          cursor: 'pointer',
          height: 'fit-content',
          borderWidth: 'initial',
          borderStyle: 'none',
          borderColor: 'initial',
          borderImage: 'initial',
          borderRadius: '0.2em',
          margin: '0px 0.5em 0px 0px',
          padding: '0.5em 1em',
        },
        '& .buttonLogin': {
          boxSizing: 'border-box',
          outlineStyle: 'none',
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '0.85em',
          backgroundColor: 'white',
          display: 'block',
          cursor: 'pointer',
          height: 'fit-content',
          color: 'rgb(113, 113, 113)',
          borderRadius: '0.2em',
          margin: '0px 0px 0px 0.5em',
          padding: '0.5em 0.75em',
          borderWidth: 'initial',
          borderStyle: 'none',
          borderColor: 'initial',
          borderImage: 'initial',
        },
        '& svg': {
          fontSize: '1.4em',
          verticalAlign: 'middle',
        }
      },
})



class TopBar extends React.Component {


    constructor(props) {
      super(props);
      this.state = {
        menus: [],
        showUserMenu: false,
        userName: this.props.username,
      }    
    }
    componentDidMount() {
        NSCTotalService.getMenus().then((data) => this.setState({menus: data}));
            }

    handleLoginChange() {
    
      if(Auth.isAuthenticated()){
        const user = decode(Auth.getData().data.id_token)
        this.setState({
          userName: user.given_name,
        })
      }
    }

    handleMenuChange = () => {
      this.setState({ showMobileMenu: {} });
      const menuVisibility = (this.state.showMenu.display === 'block') ? { display: 'none' } : { display: 'block' };
      this.setState({ showMenu: menuVisibility });
    }
  
    handleMenuMobileChange = () => {
      this.setState({ showMenu: {} });
      const menuStyle = (this.state.showMobileMenu.width === '268px') ? { width: '0px', left: '-300px' } : { width: '268px', left: '0px' };
      this.setState({ showMobileMenu: menuStyle });
    }
  
    handleUserMenuChange = () => {
      this.popup.handleUserMenuChange();
    }

    render () {
        const { classes } = this.props;
        const { menus } = this.state;
       
        // let allMenus = NSCTotalService.getMenus().then((data) => this.setState({menus: data}));
      
        return (
          <div className="topBarContainer">
            <div className="containerPrincipal">
                <ul className={classes.listItems}>
                {menus.topbar ? menus.topbar.links.map((menuItem) => {
                    if(menuItem.label === 'Publicidade Legal' || menuItem.label ==='Empregos'){
                        return null;
                    }
                    return(<li key={menuItem.url} style={{listStyle: 'none'}} name={menuItem.label}>
                    <Link to={menuItem.url.path}>{menuItem.label}</Link>
                    </li>)
                }): null }
                </ul>
                <div className={classes.containerRight} style={{ display: '' }}>
                  <button className="buttonLogin" onClick={this.handleUserMenuChange}>
                    <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" height="1em" width="1em" viewBox="0 0 40 40">
                      <g>
                        <path d="m20 23.4c4.5 0 13.4 2.1 13.4 6.6v3.4h-26.8v-3.4c0-4.5 8.9-6.6 13.4-6.6z m0-3.4c-3.7 0-6.6-3-6.6-6.6s2.9-6.8 6.6-6.8 6.6 3.1 6.6 6.8-2.9 6.6-6.6 6.6z"></path>
                      </g>
                    </svg> { this.props.username == null ? <a style={{color: 'rgb(113, 113, 113)'}} href={UrlHelper.buildLoginUrl()}>Entrar</a> : this.props.username }
                  </button>
                  <UserPainelWidget  isLogged={this.props.username} show={this.state.showUserMenu} onRef={ref => (this.popup = ref)} />
                </div>
            </div>
          </div>
        );
    }
}

export default withStyles(styles)(TopBar);
